export const IS_DEVELOPMENT =
  process.env.NEXT_PUBLIC_RELEASE_STAGE === 'development' ||
  process.env.NEXT_PUBLIC_RELEASE_STAGE === 'dev';

export const IS_STAGING =
  process.env.NEXT_PUBLIC_RELEASE_STAGE === 'sta1' ||
  process.env.NEXT_PUBLIC_RELEASE_STAGE === 'sta2';
